import { IData } from "../../interfaces";
import { SAVE_DATA } from "./types";

export const INITIAL_STATE: IData = {
  firstName: '',
  lastName: '',
  phone: '', 
  email: '',
  cpf: '',
  rg: '',
  birthDate: null,
  list: []
}

export const dataReducer = (state: IData, action: {payload?: IData, type: string}) => {
  switch (action.type) {
    case SAVE_DATA:
      return {
        ...state,
        ...action.payload
      };
    default:
     return {...state};
  }
};